import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决二次点击相同路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component:resolve => require(['./views/Home.vue'],resolve),
        },{
            path: '/introduction',
            name: 'introduction',
            component: resolve => require(['./views/Introduction.vue'],resolve),
        },{
            path: '/news',
            name: 'news',
            component: resolve => require(['./views/News.vue'],resolve),
            children: [{
                path: '/news',
                component: resolve => require(['./components/news/List.vue'],resolve),
            },{
                path: '/news/cont',
                component: resolve => require(['./components/news/Cont.vue'],resolve),
            }]
        },{
            path: '/service',
            name: 'service',
            component: resolve => require(['./views/Service.vue'],resolve),
            children: [{
                path: '/service',
                component: resolve => require(['./components/service/List.vue'],resolve),
            },{
                path: '/service/cont',
                component: resolve => require(['./components/service/Cont.vue'],resolve),
            }]
        },{
            path: '/case',
            name: 'case',
            component: resolve => require(['./views/Case.vue'],resolve),
        },{
            path: '/contact',
            name: 'contact',
            component: resolve => require(['./views/Contact.vue'],resolve),
        },{
            path: '/product',
            name: 'product',
            component: resolve => require(['./views/Product.vue'],resolve),
            children: [{
                path: '/product',
                component: resolve => require(['./components/product/Specific.vue'],resolve),
            }]
        }
    ]
})
